export enum ClinicalCharacteristicEnum {
  TENDENCY_OBESITY = 1,
  CASTRATED = 2,
  RENAL_DISEASE = 3,
  HEART_DISEASE = 4,
  OBESITY = 5,
  WEANING = 7,
  DIABETES = 8,
  DERMATOLOGICAL_SENSITIVITY = 11,
  LONG_HAIR = 12,
  SHORT_HAIR = 13,
  UROLITHIASIS = 14,
  HEALTHY = 15,
  GASTROINTESTINAL_DISEASES = 16,
  ADVERSE_FOOD_REACTIONS = 17,
  PREGNANT = 18,
  LACTATING = 19
}
